/* eslint-disable no-param-reassign */
import { KEYS } from "./constants";
// eslint-disable-next-line import/no-cycle
import { store } from "../../../../store";
import { selectDataByCustomer as selectEntitiesByCustomer } from "../Entities/selectors";
import { selectDataByCustomer as selectAreasByCustomer } from "../Areas/selectors";

const _getState = () => store.getState();

const isDefined = v => v !== undefined && v !== null;

export const getDefaultCustomer = (pickerCustomerName, customers) => { 
  if (pickerCustomerName && pickerCustomerName !== 'Aegion') { 
    return customers.find(c => c.name === pickerCustomerName);
  }
  return undefined;
}

export const getDefaultAegionPm = (pickerCustomerName, aegionPms) => { 
  if (pickerCustomerName && pickerCustomerName !== 'Aegion') { 
    return aegionPms.find(u => (u.userid || '').toUpperCase() === 'NA' || (!u.userid && (u.fullName || '').toUpperCase() === 'NA'));
  }
  return undefined;
}

export const getDefaultJobStatus = (pickerCustomerName, jobStatuses) => { 
  if (pickerCustomerName && pickerCustomerName !== 'Aegion') { 
    return jobStatuses.find(s => s.code === 'COMPLETE');
  }
  return undefined;  
}

export const createNewJobLineObject = (defaultProps = {}) => { 
  const _now = new Date(new Date().setHours(8, 0, 0, 0)).toISOString(); // set time to 8 am so we don't have to worry about timezones.
  const item = {
    [KEYS.LINE]: undefined,
    [KEYS.AUTO_GENERATE_JOB_NUMBER]: true,
    [KEYS.JOB_NUMBER]: undefined,
    [KEYS.JOB_START_DATE]: _now,
    [KEYS.JOB_END_DATE]: _now,
    [KEYS.JOB_DESCRIPTION]: '',
    [KEYS.JOB_STATUS]: undefined,
    [KEYS.AEGION_PROJECT_MANAGER]: undefined,

    [KEYS.CUSTOMER]: undefined,
    [KEYS.CUSTOMER_ENTITY]: undefined,
    [KEYS.CUSTOMER_AREA]: undefined,
    [KEYS.CUSTOMER_PIPE]: undefined,
    [KEYS.CUSTOMER_REG_STATUS]: undefined,
    [KEYS.CUSTOMER_PROJECT_MANAGER]: undefined,
    [KEYS.CUSTOMER_CORROSION_TECHNICIAN]: undefined,
  };

  return {
    ...item,
    ...defaultProps,
  }
};

const _nullIfMismatch = (jobLineClone, prop, idProp, idValue) => {
  const current = (jobLineClone[prop] || {})[idProp];
  const next = idValue;

  if (!next || (isDefined(current) && isDefined(next) && current !== next)) {
    jobLineClone[prop] = undefined;
  }
}

const _updateCustomer = (jobLineClone, customer) => { 
  jobLineClone[KEYS.CUSTOMER] = customer;
  const updateKeys = [
    KEYS.LINE,
    KEYS.AUTO_GENERATE_JOB_NUMBER,
    KEYS.JOB_NUMBER,
    KEYS.CUSTOMER_ENTITY,
    KEYS.CUSTOMER_AREA,
    KEYS.CUSTOMER_PIPE,
    KEYS.CUSTOMER_REG_STATUS,
    KEYS.CUSTOMER_PROJECT_MANAGER,
    KEYS.CUSTOMER_CORROSION_TECHNICIAN,
  ];
  updateKeys.forEach(key => { 
    _nullIfMismatch(jobLineClone, key, 'customerId', customer?.id);
  });

  return jobLineClone
}


const _updateEntity = (jobLineClone, entity) => { 
  jobLineClone[KEYS.CUSTOMER_ENTITY] = entity;
  const updateKeys = [ KEYS.CUSTOMER_AREA, KEYS.CUSTOMER_PIPE ];
  updateKeys.forEach(key => { 
    _nullIfMismatch(jobLineClone, key, 'entityId', entity?.id);
  });

  return jobLineClone;
}


const _updateArea = (jobLineClone, area) => { 
  jobLineClone[KEYS.CUSTOMER_AREA] = area;
  const updateKeys = [ KEYS.CUSTOMER_PIPE ];
  updateKeys.forEach(key => { 
    _nullIfMismatch(jobLineClone, key, 'areaId', area?.id);
  });

  // update items upstream
  const customer = jobLineClone[KEYS.CUSTOMER];
  const entities = selectEntitiesByCustomer(_getState(), { customer: customer?.name }) || [];

  if (area?.entityId) {
    const _newEntity = entities.find(e => e.id === area?.entityId);
    jobLineClone[KEYS.CUSTOMER_ENTITY] = _newEntity || undefined;
  }

  return jobLineClone;
}

const _updatePipe = (jobLineClone, pipe) => { 
  jobLineClone[KEYS.CUSTOMER_PIPE] = pipe;

  // update items upstream
  const customer = jobLineClone[KEYS.CUSTOMER];
  const entities = selectEntitiesByCustomer(_getState(), { customer: customer?.name }) || [];
  const areas = selectAreasByCustomer(_getState(), { customer: customer?.name }) || [];

  if (pipe?.entityId) {
    const _newEntity = entities.find(e => e.id === pipe?.entityId);
    jobLineClone[KEYS.CUSTOMER_ENTITY] = _newEntity || undefined;
  }

  if (pipe?.areaId) {
    const _newArea = areas.find(a => a.id === pipe?.areaId);
    jobLineClone[KEYS.CUSTOMER_AREA] = _newArea || undefined;
  }

  return jobLineClone;
}

export const updateJobLineObject = (current = {}, props = {}) => {
  const clone = { ...current };

  const propCount = Object.keys(props).length;
  if (propCount > 1) {
    return {
      ...clone,
      ...props,
    }
  }

  if (propCount === 1) {
    const prop = Object.keys(props)[0];
    switch (prop) {
      case KEYS.CUSTOMER:
        return _updateCustomer(clone, props[prop]);
      case KEYS.CUSTOMER_ENTITY:
        return _updateEntity(clone, props[prop]);
      case KEYS.CUSTOMER_AREA:
        return _updateArea(clone, props[prop]);
      case KEYS.CUSTOMER_PIPE:
        return _updatePipe(clone, props[prop]);
            default:
        return {
          ...clone,
          ...props,
        };
    }
  }

  return clone;
}

export default {
  getDefaultCustomer,
  getDefaultAegionPm,
  getDefaultJobStatus,
  createNewJobLineObject,
  updateJobLineObject
};
